export const AUTOSUGGEST_URL =
  'https://ground-auto-suggest.makemytrip.com/rails/autosuggest/stations?search_query=__query__&limit=__limit__&version=v1&input_language=__language__&rails-lang-code=__langcode__';

export const HINDI_KEY = 'hi';
export const ENG_KEY = 'en';
export const AUTO_COMPLETE_SEACH_LIMIT = 15;
